import { useMutation } from '@tanstack/react-query';
import ApiService from 'src/services/ApiService';

export const useMagicLinkRequest = () => {
  return useMutation({
    mutationKey: ['/magic-link/request'],
    mutationFn: ApiService.auth.magicLinkRequest,
  });
};
